<ng-container *ngIf="display()">
  <ts-badge variant="info" [text]="text()" [class]="class" />
</ng-container>
